const { log } = require("app-lib-log");
/**
 * 错误的定义
 *
 */
const ERROR_CODE = {
  ERROR: -1, // 终止程序 往往有 message
  WARN: 1, // 警告 不终止程序
  SUCESS: 0,
};

let CODES = [];
for (let key in ERROR_CODE) {
  CODES.push(ERROR_CODE[key]);
}

const LOG_FN = {
  [ERROR_CODE.ERROR]: "e",
  [ERROR_CODE.WARN]: "w",
  [ERROR_CODE.SUCESS]: "s",
};
/**
 * msg 打印的内容
 */
class AppError {
  /**
   *
   * @param {*} msg  打印的日志内容 可以是数组
   * @param {*} code 打印日志的错误格式
   * @param {*} cfg  配置
   */
  constructor(msg, code = ERROR_CODE.WARN, cfg = {}) {
    if (!CODES.includes(code)) {
      throw log.me(
        `create AppError code [${code}] is no't in ERROR_CODE [${CODES}] `
      );
    }
    let message = Array.isArray(msg) ? msg : msg == void 0 ? [] : [msg];
    let config = {
      trace: false, // 默认打印堆栈
      module: true, // 默认模块化打印
      data: undefined, // 接受的数据
      print: true,
      ...cfg,
    };
    this.options = { message, code, config };
    config.print && this.print();
  }
  // 后续扩展功能
  print(option = {}) {
    let { message, code, config } = { ...this.options, ...option };
    let { trace, module } = config;
    if (message && message.length) {
      let fnName = [module && "m", LOG_FN[code], trace ? "" : "n"].join("");
      let fn = log[fnName];
      if (fn) {
        fn.apply(log, message);
      } else {
        throw log.me(`log no exist ${fnName} function`);
      }
    }
  }
  isError() {
    return this.options.code === ERROR_CODE.ERROR;
  }
  noError() {
    return this.options.code === ERROR_CODE.SUCESS;
  }
}

module.exports = {
  AppError,
  ERROR_CODE: ERROR_CODE,
};
